import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
  Table,
  Divider,
  Row,
  Col,
  Avatar,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import { genFormItemAtrribute } from 'libs/FormHelper';
import Validator from 'validatorjs';
import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import GoogleMapReact from 'google-map-react';
import brands from './brands.json';
import 'braft-editor/dist/index.css';
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils';
import TextArea from 'antd/lib/input/TextArea';
const Option = Select.Option;

const cardBodyStyle = { padding: 8, fontSize: 8 };
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

export default class BrandInfo extends Component {
  formRef = React.createRef();
  state = {
    brandInfo: {
      id: null,
      status: 1,
      name: null,
      logo: null,
      image: null,
      type: 1,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    isImage: false,
    desc: null,
    en_desc: null,
    giftStore: [],
  };

  componentDidMount() {
    AppHelper.updateConfig();

    this.fetchData();
  }

  fillData = (data = _.cloneDeep(devBrandInfo)) => {
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料
    if (!_.isString(data.logo)) {
      data.logo = null;
    } else {
      data.logo = {
        id: 1,
        path: data.logo,
        url: data.logo_url,
      };
    }

    if (!_.isString(data.image)) {
      data.image = null;
    } else {
      data.image = {
        id: 2,
        path: data.image,
        url: data.image_url,
      };
    }

    data.deliveries = _.map(data.deliveries, (vendor) => ({
      ...vendor,
      image:
        _.get(vendor, 'icon_url') !== null
          ? {
              uid: 0,
              path: _.get(vendor, 'icon'),
              url: _.get(vendor, 'icon_url'),
            }
          : null,
    }));
    if (!_.isBoolean(data.status)) data.status = data.status === 1;
    //_.set(this, 'state.desc',data.desc)
    //_.set(this, 'state.en_desc',data.en_desc)
    //data.desc=BraftEditor.createEditorState(data.desc)
    //data.en_desc=BraftEditor.createEditorState(data.en_desc)
    this.formRef.current.setFieldsValue(data);
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/brands/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/brands');
        return;
      }

      this.fillData(data);
      this.setState({ data: data, giftStore: data.gift_store });
    });
  };
  handleChange = (editorState) => {
    this.setState({
      desc: editorState,
    });
  };
  handleChange_en = (editorState) => {
    this.setState({
      en_desc: editorState,
    });
  };
  submitData = (brandInfo = {}) => {
    // 把Control元件轉換回上傳資料
    brandInfo.logo = _.get(brandInfo, 'logo.path');
    brandInfo.image = _.get(brandInfo, 'image.path');
    //const desc = brandInfo.desc.toHTML()
    //var desc = _.get(this,'state.desc').toHTML()
    //desc = _.get(this,'state.desc').toHTML()
    //var en_desc = _.get(this,'state.en_desc').toHTML()
    //en_desc = _.get(this,'state.en_desc').toHTML()
    //brandInfo.desc = desc
    //brandInfo.en_desc = en_desc
    brandInfo.deliveries = _.map(brandInfo.deliveries, (vendor) => ({
      ...vendor,
      icon: _.get(vendor, 'image.path'),
    }));
    brandInfo.gift_store = _.map(brandInfo.gift_store, (gifts) => ({
      id: gifts.store_id,
      is_vip: gifts.is_vip,
      is_gift: gifts.is_gift,
    }));
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    brandInfo.user_id = current_user.ID;
    const id = _.get(this, 'props.match.params.id', '');

    console.log('submitData', brandInfo);
    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(
      API_HOST + `/api/mgt/v1/brands/${id}`,
      brandInfo,
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });

          return this.setState({ messages: data.messages || {} });
        }

        const { data: { id: new_id } = {} } = res;

        if (new_id != id) {
          message.success('建立成功');
          this.setState({ brandInfo: data });

          return this.props.history.replace(`/brands/view/${new_id}`);
        }

        message.success('更新成功');
      }
    );
  };
  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(API_HOST + `/api/mgt/v1/brands/${id}`, {}, (state, res) => {
      this.setState({ isDeleteUser: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      notification['success']({
        message: '刪除成功',
      });

      return this.props.history.replace(`/brands`);
    });
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };
  render() {
    const desc = _.get(this, 'state.desc');
    const en_desc = _.get(this, 'state.en_desc');
    const controls = [
      'font-size',
      'line-height',
      'text-color',
      'bold',
      'italic',
      'underline',
      'text-align',
      'text-color',
      'blockquote',
      'separator',
      'headings',
      'undo',
      'redo',
      'separator',
    ];
    const errors = _.get(this, 'state.validator.errors', new Errors());
    // 登入使用者的權限
    const editorPermissions = _.get(this.props, 'auth.permissions', {});

    const options = _.get(this, 'props.app.options', {});
    const uploadList =
      this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue('uploadList'))
        ? this.formRef.current.getFieldValue('uploadList')
        : [];

    const id = _.get(this, 'props.match.params.id', '');
    const privileges = _.get(window, 'VC_CONFIG.privileges', {});
    const brandsModify = _.get(privileges, 'brands.modify', []);
    const canCreate = _.get(privileges, 'brands.create', false);
    const canEdit = _.indexOf(brandsModify, 'all') !== -1 || brandsModify;

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/brands`}>品牌管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>品牌資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          品牌資訊
          <span />
        </h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => {
                this.submitData(values);
                console.log('values', values);
              }}
              onKeyDown={(e) => {
                this.enterNotSubmit(e);
                console.log(e);
              }}
              onFieldsChange={(changedFields) => {
                console.log('changedFields', changedFields);
              }}
              onValuesChange={(changedValues) => {
                console.log('changedValues', changedValues);
              }}
              //onValuesChange={(changedFields, allFields) => console.log('onValuesChange', changedFields)}
            >
              {(canCreate || canEdit) && (
                <Form.Item
                  style={{ textAlign: 'right' }}
                  taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
                >
                  <Button
                    type='primary'
                    htmlType='submit'
                    style={{ marginLeft: 8 }}
                    loading={this.state.isSubmitData}
                  >
                    儲存
                  </Button>
                </Form.Item>
              )}
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute(
                    'logo',
                    '品牌 寬137.5x高137.5 (1:1)'
                  )}
                  style={{ minHeight: 166 }}
                >
                  <AvatarUpload />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('image', '形象圖 寬1080x高400')}
                  style={{ minHeight: 166 }}
                >
                  <AvatarUpload
                    listType='picture-text'
                    className='avatar-uploader'
                  />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('name', '品牌名稱')}>
                  <Input />
                </Form.Item>
                <Form.Item {...genFormItemAtrribute('en_name', '英文品牌名稱')}>
                  <Input />
                </Form.Item>
                <Form.Item {...genFormItemAtrribute('sort', '排序')}>
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('status', '狀態', 'checked')}
                >
                  <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('type', '類別')}>
                  <Select>
                    <Option value={1}>品牌購物</Option>
                    <Option value={2}>美食餐廳</Option>
                  </Select>
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('desc', '品牌說明')}
                  validateTrigger='onBlur'
                >
                  <Input.TextArea rows={5} />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('en_desc', '英文品牌說明')}
                  validateTrigger='onBlur'
                >
                  <Input.TextArea rows={5} />
                </Form.Item>
              </div>
              <Form.Item {...genFormItemAtrribute('categorie_ids', '品牌類別')}>
                <Checkbox.Group>
                  <Divider>品牌分類</Divider>
                  <List
                    grid={listGrid}
                    dataSource={_.get(options, 'brand_categories', [])}
                    renderItem={(item) => (
                      <List.Item>
                        <Checkbox value={item.id}>{item.name}</Checkbox>
                      </List.Item>
                    )}
                  />

                  <Divider>美食分類</Divider>
                  <List
                    grid={listGrid}
                    dataSource={_.get(options, 'food_categories', [])}
                    renderItem={(item) => (
                      <List.Item>
                        <Checkbox value={item.id}>{item.name}</Checkbox>
                      </List.Item>
                    )}
                  />
                </Checkbox.Group>
              </Form.Item>
              <Divider>服務項目</Divider>

              <Form.List name='gift_store'>
                {(fields, { add, remove, move }) => {
                  const giftStoreForm = this.state.giftStore;
                  const giftStore = fields.map((field, idx) => {
                    return {
                      ...giftStoreForm[idx],
                    };
                  });
                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={giftStore}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => idx + 1,
                            },
                            {
                              dataIndex: 'store_id',
                              title: '分店',
                              render: (storeId, item, idx) => {
                                return (
                                  <Form.Item
                                    {...genFormItemAtrribute([idx, 'store_id'])}
                                  >
                                    <Select
                                      showSearch
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                    >
                                      {_.map(
                                        _.get(options, 'stores', []),
                                        (item) => (
                                          <Option key={item.id} value={item.id}>
                                            {item.name}
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                );
                              },
                            },
                            {
                              dataIndex: 'is_vip',
                              title: '',
                              render: (is_vip, item, idx) => {
                                return (
                                  <Form.Item
                                    {...genFormItemAtrribute([idx, 'is_vip'])}
                                  >
                                    <Checkbox
                                      checked={item.is_vip === 1}
                                      onChange={(e) => {
                                        const giftStore = [
                                          ...this.formRef.current.getFieldValue(
                                            'gift_store'
                                          ),
                                        ];
                                        giftStore[idx].is_vip = e.target.checked
                                          ? 1
                                          : 0;
                                        this.formRef.current.setFieldsValue({
                                          gift_store: giftStore,
                                        });
                                        this.setState({
                                          giftStore: giftStore,
                                        });
                                        console.log('giftStore', giftStore);
                                      }}
                                    >
                                      VIP
                                    </Checkbox>
                                    <Checkbox
                                      checked={item.is_gift === 1}
                                      onChange={(e) => {
                                        const giftStore = [
                                          ...this.formRef.current.getFieldValue(
                                            'gift_store'
                                          ),
                                        ];
                                        giftStore[idx].is_gift = e.target
                                          .checked
                                          ? 1
                                          : 0;
                                        this.formRef.current.setFieldsValue({
                                          gift_store: giftStore,
                                        });
                                        this.setState({
                                          giftStore: giftStore,
                                        });
                                        console.log('giftStore', giftStore);
                                      }}
                                    >
                                      禮券及禮物卡
                                    </Checkbox>
                                  </Form.Item>
                                );
                              },
                            },
                            {
                              dataIndex: 'delete',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Button onClick={() => add()}>新增</Button>
                    </Fragment>
                  );
                }}
              </Form.List>
            </Form>
          </div>
        </Skeleton>
      </Layout>
    );
  }
}

const devBrandInfo = {
  name: '品牌名稱',
  type: 1,
  sort: null,
  logo: null,
  image: null,
};



// WEBPACK FOOTER //
// ./src/views/Brand/BrandInfo.js